import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'lazy-sprite-sheet',
  templateUrl: './lazy-sprite-sheet.component.html',
  styleUrl: './lazy-sprite-sheet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazySpriteSheetComponent {
  readonly spriteSheet = input<SafeHtml | null>(null);
}
